import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo } from 'react';
import { useMutation } from 'shared/api/hooks';
import { LoadingButton } from '@mui/lab';
import { useConfirmDialog, useShowErrorDialog } from 'shared/hooks/ui';
import { applyFiletransferUpdate } from 'console/redux/devices/items/actions';
import { useAction } from 'shared/hooks/redux/hooks';
import { initialUpdate } from 'console/shared/components/banners/update-io-extension/model/slice';
export const UploadFirmwareButton = memo(function UploadFirmwareButton(props) {
    const { device_id, firmware_release_id, serial, hw_type, file } = props;
    const [uploadFirmwares, isLoading, response, error] = useMutation('upgrade_extensions_firmware', {
        device_id,
        firmware_release_id,
        serial,
        hw_type,
    });
    const manual_update = useMemo(() => {
        const data = new FormData();
        if (file) {
            const dont_reboot = true;
            const slow_mode = false;
            if (device_id) {
                data.append('device_id', device_id.toString());
            }
            data.append('dont_reboot', dont_reboot.toString());
            data.append('slow_mode', slow_mode.toString());
            data.append('serial', serial.toString());
            data.append('hw_type', hw_type.toString());
            data.append('firmware', file);
            data.append(`firmware_remote_filename`, file.name);
        }
        return data;
    }, [file, device_id, serial, hw_type]);
    const [uploadFile, isLoadingFile, responseFile, errorFile] = useMutation('upgrade_extensions_firmware_custom', manual_update);
    const _applyTransfer = useAction(applyFiletransferUpdate);
    const [ConfirmDialog, openConfirmDialog] = useConfirmDialog();
    const ErrorDialog = useShowErrorDialog(error ?? errorFile);
    useEffect(() => {
        if (response != null && device_id != null) {
            response.transfers.forEach((tr) => _applyTransfer(device_id, tr));
        }
    }, [response]);
    useEffect(() => {
        if (responseFile != null && device_id != null) {
            _applyTransfer(device_id, responseFile.transfer);
        }
    }, [responseFile]);
    const _initialUpdate = useAction(initialUpdate);
    const onConfirm = useCallback(() => {
        if (device_id != null) {
            _initialUpdate({ device_id });
        }
        if (file != null) {
            uploadFile();
            return;
        }
        uploadFirmwares();
    }, [file, device_id]);
    return (_jsxs(_Fragment, { children: [_jsx(LoadingButton, { loading: isLoading || isLoadingFile, color: "secondary", disabled: file == null && firmware_release_id == '', onClick: openConfirmDialog, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C" }), _jsx(ConfirmDialog, { onConfirm: onConfirm, children: "\u0423\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043F\u0440\u043E\u0448\u0438\u0432\u043A\u0443?" }), _jsx(ErrorDialog, { onRepeat: onConfirm })] }));
});
